import axios from 'axios'

const API_BASE = (import.meta.env.VITE_APP_API_GATEWAY_URL as string) ?? ''
const TOKEN_KEY = 'access_token'

export const PROJECT_DEFINATIONS = '/awgment-llm-local/get_project_definitions'

export interface ProjectDefinitionMetadata {
  description?: string
  [key: string]: unknown
}

export interface ProjectDefinitionItem {
  _id?: string
  project_name?: string
  metadata?: ProjectDefinitionMetadata
  created_at?: string
  timestamp?: string
  priority?: string
  status?: string
  user_access?: string[]
  [key: string]: unknown
}

export interface ProjectDefinitionResponse {
  projects?: ProjectDefinitionItem[]
  [key: string]: unknown
}

export interface ProjectDefinitionApiResult {
  success: boolean
  data?: ProjectDefinitionResponse
  message?: string
}

export const projectDefinationApi =
  async (): Promise<ProjectDefinitionApiResult> => {
    try {
      const response = await axios.get(`${API_BASE}${PROJECT_DEFINATIONS}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem(TOKEN_KEY)}`,
        },
      })

      const { data, status } = response
      if (status === 200) {
        return {
          success: true,
          data,
        }
      }

      return {
        success: false,
        message: data?.message ?? 'Unable to fetch project definitions',
      }
    } catch (error) {
      console.error('Error fetching project definitions:', error)
      return {
        success: false,
        message: 'Unable to fetch project definitions',
      }
    }
  }
